import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { ArrowRight, LucideIcon } from "lucide-react";
import { Link } from "react-router-dom";

interface RelatedSolution {
  icon: LucideIcon;
  title: string;
  description: string;
  link: string;
  gradient: string;
}

interface RelatedSolutionsSectionProps {
  solutions: RelatedSolution[];
}

const RelatedSolutionsSection = ({ solutions }: RelatedSolutionsSectionProps) => {
  return (
    <section className="mb-20">
      <h2 className="text-3xl font-bold text-center mb-4">Explore Related Solutions</h2>
      <p className="text-muted-foreground text-center mb-12 max-w-2xl mx-auto">
        See how other industries benefit from our platform
      </p>
      <div className="grid md:grid-cols-3 gap-6">
        {solutions.map((solution, index) => (
          <Card key={index} className="p-6 hover:shadow-lg transition-all hover:border-primary/50 group overflow-hidden relative">
            <div className={`absolute inset-0 opacity-0 group-hover:opacity-10 transition-opacity ${solution.gradient}`} />
            <div className="relative z-10">
              <div className="mb-4">
                <div className="w-12 h-12 rounded-lg bg-primary/10 flex items-center justify-center group-hover:bg-primary/20 transition-colors">
                  <solution.icon className="h-6 w-6 text-primary" />
                </div>
              </div>
              <h3 className="text-lg font-bold mb-2">{solution.title}</h3>
              <p className="text-sm text-muted-foreground mb-4">{solution.description}</p>
              <Button variant="link" className="p-0 h-auto" asChild>
                <Link to={solution.link}>
                  View solution <ArrowRight className="ml-2 h-4 w-4" />
                </Link>
              </Button>
            </div>
          </Card>
        ))}
      </div>
    </section>
  );
};

export default RelatedSolutionsSection;
